import { defineComponent as _defineComponent } from 'vue'
import { useImage } from '@/shared/composables/image'
import { useSanitize } from '@/services/useSanitize'
import { IEventEdit } from '@/enitites/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventGeneralInfo',
  props: {
    eventData: null
  },
  setup(__props: any) {



const { getImageById } = useImage()
const { sanitize } = useSanitize()

return { __sfc: true,getImageById, sanitize }
}

})